/* eslint-disable max-len */
import { createContext, useContext, useState } from 'react';
import React from 'react';

// Initial state object for reuse
const initialAdvancedAdminCorSearchState = {
    "user_id": '',
    "user_name": '',
    "user_name_domain": '',
    "first_name": '',
    "last_name": '',
    "user_type": [],
    "status": [],
    "email_address": '',
    "email_address_domain": '',
    "mobile_number_code": '',
    "mobile_number": '',
    "main_number_code": '',
    "main_number": '',
    "created_day": '',
    "created_month": '',
    "created_year": '',
    "user_id_inverse": '',
    "user_name_inverse": '',
    "first_name_inverse": '',
    "last_name_inverse": '',
    "mobile_number_inverse": '',
    "main_number_inverse": '',
    "email_address_inverse": '',
    "created_date_inverse": '',
    "user_type_inverse": '',
    "status_inverse": '',
    "match": false,
};

// Create the context
const AdminOrCorporateSearchContext = createContext();

// Create a custom hook to use the context
export const useAdminOrCorporateSearch = () => useContext(AdminOrCorporateSearchContext);

// Define the provider component
export const AdminOrCorporateSearchProvider = ({ children }) => {
    const [advancedAdminCorSearch, setAdvancedAdminCorSearch] = useState(initialAdvancedAdminCorSearchState);

    // Define the function to reset the state using the initial state constant
    const resetAdvancedAdminCorSearch = () => {
        setAdvancedAdminCorSearch(initialAdvancedAdminCorSearchState);
    };

    return (
        <AdminOrCorporateSearchContext.Provider value={{ advancedAdminCorSearch, setAdvancedAdminCorSearch, resetAdvancedAdminCorSearch }}>
            {children}
        </AdminOrCorporateSearchContext.Provider>
    );
};
